import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import sage from "../../../images/splash/sage.jpeg";
import Nav from "react-bootstrap/Nav";
import { Tabs, Tab } from "react-bootstrap";

import { Navbar, NavDropdown } from "react-bootstrap";
import { Card, Form, Button, Table } from "react-bootstrap";
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from "react-bootstrap/Modal";
import Loader from "../Loader";
import Pagination from "react-js-pagination";
import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from "@material-ui/core";
import ReactPaginate from "react-paginate";

import CouponModal from "./CouponModal.jsx";
import CouponModalPremium from "./CouponModalPremium.jsx";

const Coupon = () => {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showpostModel, setShowpostModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [runningList, setRunningList] = useState([]);
  const [runningTimeList, setRunningTimeList] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const [prestatusFilter, setPreStatusFilter] = useState("all");
  const history = useHistory();
  const [authError, setAuthError] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [validationErrorsPreminum, setValidationErrorsPreminum] = useState({});

  //COUPON
  const [popupPremiumData, setpopupPremiumData] = useState(null); // Use null for a single object
  const [referalCode, setReferalCode] = useState([]); // Use null for a single object

  const [activeCoupon, setActiveCoupon] = useState([]); // State to hold the active coupon

  const [isOpen, setIsOpen] = useState(false);
  const [showAd, setAdIsOpen] = useState(false);
  const [showAdPremium, setAdPreIsOpen] = useState(false);

  const [show, setShow] = useState(false);
  const [showlist, setShowList] = useState(false);
  const [Customers, setCustomers] = useState(false);

  const [showPremium, setShowPremium] = useState(false);
  const [isEditPremium, setEditPremium] = useState(false);

  const [isEdit, setEdit] = useState(false);

  const [CustomerCoupon, setCustomerCoupon] = useState([]); // State to store coupon data

  const [coupons, setCoupons] = useState([]); // State to store coupon data
  const [premiumcoupons, setPremiumCoupons] = useState([]); // State to store coupon data

  const [showModal, setShowModal] = useState(false);
  const [activeKey, setActiveKey] = useState("tab1");

  const [viewMod, setViewMod] = useState(false);
  const [viewModPremium, setViewModPremium] = useState(false);

  const [search, setSearch] = useState("");
  const [searchPremium, setSearchPremium] = useState("");

  const [currentPage, setCurrentPage] = useState(0);
  const [currentPagePremium, setCurrentPagePremium] = useState(0);

  const itemsPerPage = 10;
  const itemsPerPagePremium = 10;

  //popup setPremiumCouponId
  const [premiumCouponId, setPremiumCouponId] = useState(new Set());

  const [selectedCoupons, setSelectedCoupons] = useState(new Set());
  const [selectedCouponsDetails, setSelectedCouponsDetails] = useState([]);
  const [allCoupons, setAllCoupons] = useState([]);
  const [allCouponsPremium, setAllCouponsPremium] = useState([]);

  const [formData, setFormData] = useState({
    coupon_name: "",
    description: "",
    discount_type: "",
    discount_value: "",
    from_date: "",
    to_date: "",
    used_count: 0,
    is_active: 1,
    coupon_code: "",
  });
  const [formDataPremiumAdd, setFormDataPremiumAdd] = useState({
    coupon_name: "",
    description: "",
    discount_type: "",
    discount_value: "",
    from_date: "",
    to_date: "",
    used_count: 0,
    is_active: 1,
    unused_count: 1,
    expired_count: 0,
    coupon_code: "",
  });
  const [formDataPremium, setFormDataPremium] = useState({
    coupon_name: "",
    description: "",
    discount_type: "",
    discount_value: "",
    from_date: "",
    to_date: "",
    used_count: 0,
    is_active: 1,
    unused_count: 1,
    expired_count: 0,
    coupon_code: "",
  });
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0"); // Pad day
  const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
  const yyyy = today.getFullYear();
  const formattedDate = `${yyyy}-${mm}-${dd}`; // Format as YYYY-MM-DD

  const isCouponActive = (toDate) => {
    if (!toDate) return false;

    const [day, month, year] = toDate.split("-");
    const formattedToDate = new Date(`${year}-${month}-${day}`);
    const today = new Date();

    return formattedToDate >= today;
  };

  const filteredCustomers = coupons.filter((customer) => {
    // Existing search filter
    const matchesSearch =
      customer.coupon_name?.toLowerCase().includes(search.toLowerCase()) ||
      customer.coupon_code?.toLowerCase().includes(search.toLowerCase()) ||
      customer.description?.toLowerCase().includes(search.toLowerCase()) ||
      customer.discount_value
        ?.toString()
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      customer.from_date
        ?.toString()
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      customer.to_date?.toString().toLowerCase().includes(search.toLowerCase());

    // Status filter
    const matchesStatus =
      statusFilter === "all" ||
      (statusFilter === "active" && isCouponActive(customer.to_date)) ||
      (statusFilter === "expired" && !isCouponActive(customer.to_date));

    return matchesSearch && matchesStatus;
  });

  const filteredcoupons = premiumcoupons.filter((coupon) => {
    // Existing search filter
    const matchesSearch =
      coupon.coupon_name?.toLowerCase().includes(searchPremium.toLowerCase()) ||
      coupon.description?.toLowerCase().includes(searchPremium.toLowerCase()) ||
      coupon.discount_value
        ?.toString()
        .toLowerCase()
        .includes(searchPremium.toLowerCase()) ||
      coupon.from_date
        ?.toString()
        .toLowerCase()
        .includes(searchPremium.toLowerCase()) ||
      coupon.to_date
        ?.toString()
        .toLowerCase()
        .includes(searchPremium.toLowerCase());

    // Status filter
    const matchesStatus =
      prestatusFilter === "all" ||
      (prestatusFilter === "active" && isCouponActive(coupon.to_date)) ||
      (prestatusFilter === "expired" && !isCouponActive(coupon.to_date));

    return matchesSearch && matchesStatus;
  });

  const handleTabSelect = (key) => {
    setActiveKey(key);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleInputChangePremium = (e) => {
    const { name, value } = e.target;
    setFormDataPremiumAdd((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleInputChangePremiumEdit = (e) => {
    const { name, value } = e.target;
    setFormDataPremium((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const formatDate = (date) => {
    if (!date) return ""; // Return empty if no date provided
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) and pad
    const year = d.getFullYear(); // Get year
    return `${day}-${month}-${year}`; // Return formatted date
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create the payload object
    const payload = {
      coupon_name: formData.coupon_name,
      description: formData.description,
      discount_type: formData.discount_type,
      discount_value: parseFloat(formData.discount_value),
      from_date: formatDate(formData.from_date),
      to_date: formatDate(formData.to_date),
      unused_count: formData.unused_count,
      used_count: formData.used_count,
      is_active: formData.is_active,
      coupon_code: formData.coupon_code,
    };

    try {
      const response = await fetch(
        `${var_api}/api/free-coupon-master/free-coupon-master/post`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Set content type to JSON
          },
          body: JSON.stringify(payload), // Convert payload to JSON string
        }
      );

      if (response.ok) {
        await fetchCoupons(); // Fetch updated coupons
        setShow(false);
        const data = await response.json();
        console.log("Coupon created successfully!", data);
        Swal.fire({
          title: "Success",
          text: "Coupon Created Successfully.",
          icon: "success",
          confirmButtonColor: "#007500",
        });
        // Reset the form
        setFormData({
          coupon_name: "",
          description: "",
          discount_type: "",
          discount_value: "",
          from_date: "",
          to_date: "",
          used_count: 0,
          is_active: 1,
        });
      } else {
        console.error("Failed to create coupon:", response.statusText);
        Swal.fire({
          title: "Error",
          text: "Failed to create coupon. Please try again!",
          icon: "error",
          confirmButtonColor: "#007500",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again!",
        icon: "error",
        confirmButtonColor: "#007500",
      });
    }
  };
  const handleSubmitPremium = async (e) => {
    e.preventDefault();

    // Create the payload object
    const payload = {
      coupon_name: formDataPremiumAdd.coupon_name,
      description: formDataPremiumAdd.description,
      discount_type: formDataPremiumAdd.discount_type,
      discount_value: parseFloat(formDataPremiumAdd.discount_value),
      from_date: formatDate(formDataPremiumAdd.from_date),
      to_date: formatDate(formDataPremiumAdd.to_date),
      unused_count: formDataPremiumAdd.unused_count,
      used_count: formDataPremiumAdd.used_count,
      is_active: formDataPremiumAdd.is_active,
      expired_count: formDataPremiumAdd.expired_count,
    };

    try {
      const response = await fetch(
        `${var_api}/api/premium-coupon-master/premium-coupon-master/post`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Set content type to JSON
          },
          body: JSON.stringify(payload), // Convert payload to JSON string
        }
      );

      if (response.ok) {
        await fetchPremiumCoupons(); // Fetch updated coupons
        setShowPremium(false);
        const data = await response.json();
        console.log("Coupon created successfully!", data);
        Swal.fire({
          title: "Success",
          text: "Coupon Created Successfully.",
          icon: "success",
          confirmButtonColor: "#007500",
        });
        // Reset the form
        setFormDataPremiumAdd({
          coupon_name: "",
          description: "",
          discount_type: "",
          discount_value: "",
          from_date: "",
          to_date: "",
          used_count: 0,
          is_active: 1,
        });
      } else {
        console.error("Failed to create coupon:", response.statusText);
        Swal.fire({
          title: "Error",
          text: "Failed to create coupon. Please try again!",
          icon: "error",
          confirmButtonColor: "#007500",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again!",
        icon: "error",
        confirmButtonColor: "#007500",
      });
    }
  };
  const handleEdit = async (e) => {
    e.preventDefault();

    // Validation rules
    const errors = {};

    if (!formData.coupon_name?.trim()) {
      errors.coupon_name = "Coupon name is required.";
    }

    if (!formData.coupon_code?.trim()) {
      errors.coupon_code = "Coupon code is required.";
    }

    if (!formData.description?.trim()) {
      errors.description = "Description is required.";
    }

    if (!formData.discount_type) {
      errors.discount_type = "Discount type is required.";
    }

    if (!formData.discount_value || formData.discount_value <= 0) {
      errors.discount_value = "Discount value must be greater than 0.";
    }

    if (!formData.from_date) {
      errors.from_date = "From date is required.";
    }

    if (!formData.to_date) {
      errors.to_date = "To date is required.";
    } else if (new Date(formData.to_date) < new Date(formData.from_date)) {
      errors.to_date = "To date cannot be earlier than from date.";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      // Swal.fire({
      //     title: "Validation Error",
      //     text: "Please correct the highlighted errors before proceeding.",
      //     icon: "warning",
      //     confirmButtonColor: "#007500",
      // });
      return;
    }

    // Clear errors if validation passes
    setValidationErrors({});

    // Create the payload object
    const payload = {
      coupon_name: formData.coupon_name,
      description: formData.description,
      discount_type: formData.discount_type,
      discount_value: parseFloat(formData.discount_value),
      from_date: formatDate(formData.from_date),
      to_date: formatDate(formData.to_date),
      unused_count: formData.unused_count,
      used_count: formData.used_count,
      is_active: formData.is_active,
      coupon_code: formData.coupon_code,
    };

    try {
      const response = await fetch(
        `${var_api}/api/free-coupon-master/free-coupon-master/put/${formData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        await fetchCoupons();
        handleCloseEdit();

        Swal.fire({
          title: "Success",
          text: "Coupon updated successfully.",
          icon: "success",
          confirmButtonColor: "#007500",
        });

        setFormData({
          coupon_name: "",
          description: "",
          discount_type: "",
          discount_value: "",
          from_date: "",
          to_date: "",
          used_count: 0,
          is_active: 1,
          coupon_code: "",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to update the coupon. Please try again!",
          icon: "error",
          confirmButtonColor: "#007500",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again!",
        icon: "error",
        confirmButtonColor: "#007500",
      });
    }
  };

  const handleEditPremmium = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!formDataPremium.coupon_name?.trim()) {
      errors.coupon_name = "Coupon name is required.";
    }

    if (!formDataPremium.description?.trim()) {
      errors.description = "Description is required.";
    }

    if (!formDataPremium.discount_type) {
      errors.discount_type = "Discount type is required.";
    }

    if (
      !formDataPremium.discount_value ||
      formDataPremium.discount_value <= 0
    ) {
      errors.discount_value = "Discount value must be greater than 0.";
    }

    if (!formDataPremium.from_date) {
      errors.from_date = "From date is required.";
    }

    if (!formDataPremium.to_date) {
      errors.to_date = "To date is required.";
    } else if (
      new Date(formDataPremium.to_date) < new Date(formDataPremium.from_date)
    ) {
      errors.to_date = "To date cannot be earlier than from date.";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrorsPreminum(errors);
      return;
    }

    setValidationErrorsPreminum({});

    const payload = {
      coupon_name: formDataPremium.coupon_name,
      description: formDataPremium.description,
      discount_type: formDataPremium.discount_type,
      discount_value: parseFloat(formDataPremium.discount_value),
      from_date: formatDate(formDataPremium.from_date),
      to_date: formatDate(formDataPremium.to_date),
      unused_count: formDataPremium.unused_count,
      used_count: formDataPremium.used_count,
      is_active: formDataPremium.is_active,
      expired_count: formDataPremium.expired_count,
    };

    try {
      const response = await fetch(
        `${var_api}/api/premium-coupon-master/premium-coupon-master/put/${formDataPremium.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        await fetchPremiumCoupons();
        handleCloseEditPremium();
        const data = await response.json();
        Swal.fire({
          title: "Success",
          text: "Coupon Update Successfully.",
          icon: "success",
          confirmButtonColor: "#007500",
        });
        setFormDataPremium({
          coupon_name: "",
          coupon_code: "",
          description: "",
          discount_type: "",
          discount_value: "",
          from_date: "",
          to_date: "",
          used_count: 0,
          is_active: 1,
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to Update coupon. Please try again!",
          icon: "error",
          confirmButtonColor: "#007500",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again!",
        icon: "error",
        confirmButtonColor: "#007500",
      });
    }
  };

  const filteredByStatus = filteredCustomers.filter((coupon) => {
    if (statusFilter === "all") return true;
    const isActive = isCouponActive(coupon.to_date);
    return statusFilter === "active" ? isActive : !isActive;
  });
  const CouponStatusBadge = ({ toDate }) => {
    const isActive = isCouponActive(toDate);

    return (
      <span
        style={{
          backgroundColor: isActive ? "green" : "red",
          color: "white",
          padding: "5px 10px",
          borderRadius: "15px",
          fontWeight: "bold",
          display: "inline-block",
        }}
      >
        {isActive ? "Active" : "Expired"}
      </span>
    );
  };
  // Calculate pagination
  const pageCountPremium = Math.ceil(
    filteredCustomers.length / itemsPerPagePremium
  );
  const displayedCustomersPremium = filteredCustomers.slice(
    currentPagePremium * itemsPerPagePremium,
    (currentPagePremium + 1) * itemsPerPagePremium
  );
  const indexofpreminum = currentPagePremium * itemsPerPagePremium;
  const pageCount = Math.ceil(filteredcoupons.length / itemsPerPage);
  const displayedCustomers = filteredcoupons.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  const indexoffree = currentPage * itemsPerPage;

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setCurrentPage(selectedPage);
  };
  const handlePageClickPremium = (data) => {
    const selectedPage = data.selected;
    setCurrentPagePremium(selectedPage);
  };
  const handleCloseModal = () => setShowModal(false);
  //close the modal
  const handleClose = () => {
    setShow(false);
  };

  const handleShowAd = (coupon) => {
    setActiveCoupon([coupon]); // Set the clicked coupon in an array
    setAdIsOpen(true); // Open the modal
  };

  const handleShowAdPremium = (coupon) => {
    setReferalCode(coupon);
    setAdPreIsOpen(true); // Open the modal
  };

  const handleCloseAdPremium = (coupon) => {
    setAdPreIsOpen(false); // Open the modal
  };
  const handleCloseEdit = () => {
    setEdit(false);
  };
  const handleCloseEditPremium = () => {
    setEditPremium(false);
  };
  useEffect(() => {
    fetchCoupons();
    fetchPremiumCoupons();
    fetchCustomers();
  }, []);
  const fetchCustomers = async () => {
    console.log("Fetching coupons...");
    setLoading(true);
    const tokens = localStorage.getItem("token");
    console.log("Authorization token:", tokens);

    try {
      const response = await axios.get(`${var_api}/api/customers/get`, {
        headers: { Authorization: tokens },
      });
      console.log("Coupons fetched successfully:", response.data);
      setCustomers(response.data);
    } catch (error) {
      console.error(
        "Error fetching coupons:",
        error.response ? error.response.data : error.message
      );
      setShowSnackbar(true);
      setSnackbarMessage("Failed to fetch coupons.");
    } finally {
      setLoading(false);
    }
  };
  const fetchCoupons = async () => {
    console.log("Fetching coupons...");
    setLoading(true);
    const tokens = localStorage.getItem("token");
    console.log("Authorization token:", tokens);

    try {
      const response = await axios.get(
        `${var_api}/api/free-coupon-master/free-coupon-master/get`,
        {
          headers: { Authorization: tokens },
        }
      );
      console.log("Coupons fetched successfully:", response.data);
      setCoupons(response.data);
    } catch (error) {
      console.error(
        "Error fetching coupons:",
        error.response ? error.response.data : error.message
      );
      setShowSnackbar(true);
      setSnackbarMessage("Failed to fetch coupons.");
    } finally {
      setLoading(false);
    }
  };
  const fetchPremiumCoupons = async () => {
    console.log("Fetching coupons...");
    setLoading(true);
    const tokens = localStorage.getItem("token");
    console.log("Authorization token:", tokens);

    try {
      const response = await axios.get(
        `${var_api}/api/premium-coupon-master/premium-coupon-master/get`,
        {
          headers: { Authorization: tokens },
        }
      );
      console.log("Coupons fetched successfully:", response.data);
      setPremiumCoupons(response.data);
    } catch (error) {
      console.error(
        "Error fetching coupons:",
        error.response ? error.response.data : error.message
      );
      setShowSnackbar(true);
      setSnackbarMessage("Failed to fetch coupons.");
    } finally {
      setLoading(false);
    }
  };
  const toggleCouponActive = async (data, isActive) => {
    const newActiveStatus = isActive ? 0 : 1; // Toggle active status
    const payload = {
      coupon_name: data.coupon_name,
      description: data.description,
      discount_type: data.discount_type, // 0 for percentage, 1 for flat
      discount_value: parseFloat(data.discount_value),
      from_date: data.from_date,
      to_date: data.to_date,
      unused_count: data.unused_count, // Make sure this is included
      used_count: data.used_count,
      expired_count: data.expired_count, // Include this if needed
      is_active: newActiveStatus,
      coupon_code: data.coupon_code,
    };

    try {
      const response = await fetch(
        `${var_api}/api/free-coupon-master/free-coupon-master/put/${data.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload), // Directly send the payload
        }
      );

      if (response.ok) {
        await fetchCoupons(); // Fetch updated coupons
        Swal.fire({
          title: "Success",
          text: `Coupon is now ${
            newActiveStatus === 1 ? "active" : "inactive"
          }.`,
          icon: "success",
          confirmButtonColor: "#007500",
        });
      } else {
        console.error("Failed to update coupon:", response.statusText);
        Swal.fire({
          title: "Error",
          text: "Failed to update coupon. Please try again!",
          icon: "error",
          confirmButtonColor: "#007500",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again!",
        icon: "error",
        confirmButtonColor: "#007500",
      });
    }
  };
  const toggleCouponActivePremium = async (data, isActive) => {
    const newActiveStatus = isActive ? 0 : 1; // Toggle active status
    const payload = {
      coupon_name: data.coupon_name,
      description: data.description,
      discount_type: data.discount_type, // 0 for percentage, 1 for flat
      discount_value: parseFloat(data.discount_value),
      from_date: data.from_date,
      to_date: data.to_date,
      unused_count: data.unused_count, // Make sure this is included
      used_count: data.used_count,
      expired_count: data.expired_count, // Include this if needed
      is_active: newActiveStatus,
    };

    try {
      const response = await fetch(
        `${var_api}/api/premium-coupon-master/premium-coupon-master/put/${data.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload), // Directly send the payload
        }
      );

      if (response.ok) {
        await fetchPremiumCoupons(); // Fetch updated coupons
        Swal.fire({
          title: "Success",
          text: `Coupon is now ${
            newActiveStatus === 1 ? "active" : "inactive"
          }.`,
          icon: "success",
          confirmButtonColor: "#007500",
        });
      } else {
        console.error("Failed to update coupon:", response.statusText);
        Swal.fire({
          title: "Error",
          text: "Failed to update coupon. Please try again!",
          icon: "error",
          confirmButtonColor: "#007500",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again!",
        icon: "error",
        confirmButtonColor: "#007500",
      });
    }
  };

  const handleForm = async () => {
    setShow(true);
    setFormData({
      id: null,
      coupon_name: "",
      description: "",
      discount_type: "",
      discount_value: "",
      from_date: "",
      to_date: "",
      unused_count: 0,
      used_count: 0,
      coupon_code: "",
      is_active: 1,
      is_edit: false,
    });
  };

  const handleFormPremium = async () => {
    setShowPremium(true);
  };
  const handleFormPremiumClose = async () => {
    setShowPremium(false);
  };

  const handlePostCoupons = async () => {
    // Function to handle posting selected coupons
    const selectedDetails = [...selectedCoupons].map((id) => {
      const customer = Customers.find((coupon) => coupon.id === id);
      return { email: customer.email_id, premium_coupon_id: premiumCouponId };
    });

    console.log("Selected Coupons Details to Post:", selectedDetails);

    try {
      const tokens = localStorage.getItem("token");

      const response = await axios.post(
        ` ${var_api}/api/premium-coupon-user-list/premium-coupon-user-list/post-multiple`,
        selectedDetails,
        console.log("Selected Coupons Details to Post:", selectedDetails, {
          headers: { Authorization: tokens },
        })
      );

      console.log("Response from API:", response.data);
      setShowList(false);
      setSelectedCoupons(new Set()); // Clear selected coupons
      setSelectedCouponsDetails([]); // Clear selected coupon details
      // Handle success response (e.g., show a success message)
    } catch (error) {
      console.error("Error posting coupons:", error);
      // Handle error response (e.g., show an error message)
    }
  };

  const handleGoToHome = () => {
    history.push("/sb-home");
  };

  const resetForm = () => {
    setFormData({
      id: null,
      coupon_name: "",
      description: "",
      discount_type: "",
      discount_value: "",
      from_date: "",
      to_date: "",
      unused_count: 0,
      used_count: 0,
      coupon_code: "",

      is_active: false,
      is_edit: false,
    });
    handleClose();
  };

  const resetFormPremium = () => {
    setFormDataPremiumAdd({
      coupon_name: "",
      description: "",
      discount_type: "",
      discount_value: "",
      from_date: "",
      to_date: "",
      used_count: 0,
      is_active: 1,
    });
  };

  //COUPON

  const handleCustomercoupon = async (id) => {
    try {
      setViewMod(true);

      const response = await fetch(
        `${var_api}/api/free-coupon-user-list/free-coupon-user-list/get-coupon/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json(); // Parse response as JSON
      setAllCoupons(data || []); // Set data to state
      console.log(data); // Log the data
    } catch (error) {
      console.error("Error fetching coupon data:", error);
    }
  };

  const handleCustomercouponPremium = async (coupon) => {
    try {
      setViewModPremium(true);
      setpopupPremiumData(coupon); // Set the coupon data

      // Log the coupon data right after setting (will not show updated state)
      console.log("Setting popupPremiumData:", coupon);
      const response = await fetch(
        `${var_api}/api/premium-coupon-user-list/premium-coupon-user-list/get-coupon/${coupon.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json(); // Parse response as JSON
      setAllCouponsPremium(data || []);
      // Set data to state
      console.log(data); // Log the data
    } catch (error) {
      console.error("Error fetching coupon data:", error);
    }
  };
  // Handle filtering and pagination

  const handleEditCoupon = (coupon) => {
    setEdit(true);

    const formatToYYYYMMDD = (dateString) => {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
    };

    // Clone coupon and format the dates
    const formattedCoupon = {
      ...coupon,
      from_date: formatToYYYYMMDD(coupon.from_date),
      to_date: formatToYYYYMMDD(coupon.to_date),
    };
    console.log(formattedCoupon);
    setFormData(formattedCoupon); // Set the selected coupon with formatted dates
  };

  const handleEditCouponPremium = (coupon) => {
    setEditPremium(true);
    const formatToYYYYMMDD = (dateString) => {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
    };

    // Clone coupon and format the dates
    const formattedCoupon = {
      ...coupon,
      from_date: formatToYYYYMMDD(coupon.from_date),
      to_date: formatToYYYYMMDD(coupon.to_date),
    };
    console.log(formattedCoupon);
    setFormDataPremium(formattedCoupon); // Set the selected coupon to edit
  };
  const handleViewReport = () => {
    setViewMod(true);
  };
  const handleCloseMod = () => setViewMod(false);
  const handleCloseModPremium = () => setViewModPremium(false);

  const handleOpenList = (id) => {
    setPremiumCouponId(id); // Set the premium_coupon_id
    setShowList(true); // Open the list
  };
  const handleCloseList = () => setShowList(false);
  const handleCloseAd = () => setAdIsOpen(false);
  // Handle checkbox change

  const handleCheckboxChange = (coupon) => {
    const updatedSelection = new Set(selectedCoupons);
    const updatedDetails = [...selectedCouponsDetails];

    if (updatedSelection.has(coupon.id)) {
      updatedSelection.delete(coupon.id); // Unselect
      // Remove corresponding details
      setSelectedCouponsDetails(
        updatedDetails.filter((item) => item.premium_coupon_id !== coupon.id)
      );
    } else {
      updatedSelection.add(coupon.id); // Select
      // Add new detail using premiumCouponId from state
      updatedDetails.push({
        email: coupon.email_id,
        premium_coupon_id: premiumCouponId,
      });
      setSelectedCouponsDetails(updatedDetails);
      console.log(
        "Updated selected coupons details after selecting:",
        updatedDetails
      );
    }

    setSelectedCoupons(updatedSelection);
    console.log("Current selected coupons:", Array.from(updatedSelection)); // Log current selection
  };

  // Handle select all checkboxes
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = new Set(Customers.map((coupon) => coupon.id));
      const allDetails = Customers.map((coupon) => ({
        email: coupon.email_id,
        premium_coupon_id: premiumCouponId, // Use coupon.id for each detail
      }));
      setSelectedCoupons(allIds);
      setSelectedCouponsDetails(allDetails); // Store all details
      console.log("All coupons selected:", allDetails);
    } else {
      setSelectedCoupons(new Set());
      setSelectedCouponsDetails([]); // Clear details
    }
    console.log("Current selected coupons:", Array.from(selectedCoupons)); // Log current selection
  };
  return (
    <>
      {loading && <Loader />}

      <Navbar
        bg="light"
        expand="md"
        className="bg-body-tertiary"
        collapseOnSelect
        fixed="top"
      >
        <Navbar.Brand href="#home">
          <img
            src={sage}
            alt="logo"
            className="img-fluid"
            style={{ maxWidth: "200px", margin: "3px 80px" }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link
              href="#"
              style={{ color: "black", fontSize: "25px", letterSpacing: "2px" }}
            >
              Coupon
            </Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            <Nav.Link
              onClick={handleGoToHome}
              style={{ color: "black", fontSize: "15px" }}
            >
              <button
                className="btn"
                style={{ backgroundColor: "rgb(89, 128, 71)", color: "white" }}
              >
                <i className="bi bi-house"></i> Go to home
              </button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <br />
      <br />
      <br />
      <br />
      {/* <Container style={{width:'100%',justifyContent: 'center' }}> */}
      {/* <div className="tab-container"> */}

      <Tabs
        id="controlled-tab-example"
        activeKey={activeKey}
        onSelect={handleTabSelect}
        className="mb-3"
        style={{ backgroundColor: "white" }}
      >
        <Tab
          eventKey="tab1"
          title="Free Coupon"
          style={{ backgroundColor: "white" }}
        >
          {/* <div className='whole' style={{ backgroundColor: "white"}}>
                        {showSnackbar && <div className='snackbar success'>{snackbarMessage}</div>} */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              className="btn btn-md mb-4"
              id="servicecategory"
              onClick={handleForm}
              style={{
                backgroundColor: "green",
                color: "white",
                border: "none",
              }}
            >
              <i className="bi bi-plus-square"> Add Coupon</i>
            </button>

            {/* Search and filter in a row */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              {/* Search input */}
              <Form.Control
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ width: "200px" }}
              />

              {/* Dropdown filter */}
              <select
                className="form-select"
                style={{
                  width: "150px",
                  height: "40px",
                  border: "1px solid #ced4da", // Bootstrap default border
                  borderRadius: "0.375rem", // Bootstrap default border-radius
                }}
                onChange={(e) => setStatusFilter(e.target.value)}
                value={statusFilter}
              >
                <option value="all">All Coupons</option>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
              </select>
            </div>
          </div>

          <Table className="table table-hover table-striped align-middle mt-4 mb-4">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Coupon Name</th>
                <th>Coupon Code</th>
                <th>Description</th>
                <th>Discount</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Status</th>
                <th>Active</th>
                <th>Used Count</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayedCustomersPremium.length > 0 ? (
                displayedCustomersPremium.map((coupon, index) => (
                  <tr key={coupon.id}>
                    <td>{indexofpreminum + index + 1}</td>
                    <td
                      onClick={() => handleShowAd(coupon)}
                      style={{
                        textDecoration: "underline",
                        color: "blue",
                        cursor: "pointer",
                      }}
                    >
                      <a>{coupon.coupon_name}</a>
                    </td>{" "}
                    {/* Use the correct field for coupon name */}
                    <td>{coupon.coupon_code}</td>{" "}
                    {/* Use the correct field for coupon name */}
                    <td>{coupon.description}</td>{" "}
                    {/* Use the correct field for description */}
                    <td>
                      {coupon.discount_value}
                      {coupon.discount_type === 0 ? "$" : "%"}
                    </td>{" "}
                    {/* Use the correct field for discount value */}
                    <td>{coupon.from_date}</td> {/* Format from_date */}
                    <td>{coupon.to_date}</td> {/* Format from_date */}
                    <td>
                      {(() => {
                        // Parse `to_date` in dd-mm-yyyy format
                        const [day, month, year] = coupon.to_date.split("-");
                        const formattedToDate = new Date(
                          `${year}-${month}-${day}`
                        ); // Convert to yyyy-mm-dd format
                        const today = new Date(); // Current date

                        // Check if the coupon is expired or active
                        return formattedToDate < today ? (
                          <span
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              padding: "5px 10px",
                              borderRadius: "15px",
                              fontWeight: "bold",
                              display: "inline-block",
                            }}
                          >
                            Expired
                          </span>
                        ) : (
                          <span
                            style={{
                              backgroundColor: "green",
                              color: "white",
                              padding: "5px 10px",
                              borderRadius: "15px",
                              fontWeight: "bold",
                              display: "inline-block",
                            }}
                          >
                            Active
                          </span>
                        );
                      })()}
                    </td>
                    <td>
                      <Form.Check
                        type="switch"
                        label=""
                        checked={coupon.is_active === 1}
                        onChange={() =>
                          toggleCouponActive(coupon, coupon.is_active)
                        }
                      />
                    </td>
                    <td>{coupon.used_count}</td>{" "}
                    {/* Coupon count, assuming this is unused count */}
                    <td>
                      <Button
                        type="button"
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleCustomercoupon(coupon.id)}
                      >
                        <i
                          className="bi bi-eye-fill"
                          style={{
                            fontSize: "18px",
                            color: "white",
                            marginRight: "5px",
                          }}
                        ></i>
                      </Button>
                      <Button
                        type="button"
                        variant="warning"
                        onClick={() => handleEditCoupon(coupon)}
                      >
                        <i
                          className="bi bi-pencil-square"
                          style={{
                            color: "blue",
                            fontSize: "18px",
                            float: "right",
                          }}
                        ></i>
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No coupons found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {/* Pagination Controls */}

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <ReactPaginate
              previousLabel={"← Previous"}
              nextLabel={"Next →"}
              breakLabel={"..."}
              pageCount={pageCountPremium}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClickPremium}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
          {/* </div> */}
          <Modal
            className="temp"
            size="lg"
            show={viewMod}
            onHide={handleCloseMod}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>CUSTOMER DETAILS</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: "scroll" }}>
              <div>
                <Card
                  bg="light"
                  text="dark"
                  style={{
                    maxWidth: "45rem",
                    height: "auto",
                    border: "none",
                    borderBottom: "1px solid black",
                    borderRadius: "0px",
                    marginTop: "10px",
                  }}
                  className="mb-2"
                >
                  {/* <input
                type="text"
                placeholder="Search coupons"
                value={searchQuery}
                onChange={handleSearchChange}
                style={{ margin: "10px", padding: "5px", width: "30%" }}
            /> */}
                  <Table
                    className="table table-hover table-striped align-middle mt-4"
                    style={{ width: "100%", margin: "auto" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Customer Name</th>
                        <th>Email</th>
                        <th>Mobile No.</th>
                        <th>Coupon Used Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(allCoupons) && allCoupons.length > 0 ? (
                        allCoupons.map((customer, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{customer.customer_name}</td>
                            <td>{customer.customer_email}</td>
                            <td>{customer.customer_mobile}</td>
                            <td>
                              {new Date(customer.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                }
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td col="5" style={{ textAlign: "center" }}>
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {/* Pagination Controls using react-js-pagination */}
                </Card>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            className="temp"
            size="lg"
            show={viewModPremium}
            onHide={handleCloseModPremium}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title> COUPON USED DETAILS</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: "scroll" }}>
              <div>
                <Card
                  bg="light"
                  text="dark"
                  style={{
                    maxWidth: "45rem",
                    height: "auto",
                    border: "none",
                    borderBottom: "1px solid black",
                    borderRadius: "0px",
                    marginTop: "10px",
                  }}
                  className="mb-2"
                >
                  {/* <input
                type="text"
                placeholder="Search coupons"
                value={searchQuery}
                onChange={handleSearchChange}
                style={{ margin: "10px", padding: "5px", width: "30%" }}
            /> */}
                  <Table
                    className="table table-hover table-striped align-middle mt-4"
                    style={{ width: "100%", margin: "auto" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Coupon Code</th>
                        <th>Is Used</th>
                        <th>Customer Name</th>
                        <th>Customer Email ID</th>

                        <th>Customer Mobile No</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(allCouponsPremium) &&
                      allCouponsPremium.length > 0 ? (
                        allCouponsPremium.map((customer, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td
                              style={{
                                textDecoration: "underline",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => handleShowAdPremium(customer)}
                            >
                              {customer.coupon_code}
                            </td>
                            <td>
                              {customer.is_used === 1 ? "Completed" : "Active"}
                            </td>
                            {customer.used_by ? (
                              <>
                                <td>
                                  {customer.used_by.customer_name || "N/A"}
                                </td>
                                <td>
                                  {customer.used_by.customer_email || "N/A"}
                                </td>
                                <td>
                                  {customer.used_by.customer_mobile || "N/A"}
                                </td>
                              </>
                            ) : (
                              <>
                                <td>N/A</td>
                                <td>N/A</td>
                                <td>N/A</td>
                              </>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {/* Pagination Controls using react-js-pagination */}
                </Card>
              </div>
            </Modal.Body>
          </Modal>
        </Tab>
        <Tab eventKey="tab2" title="Premium Coupon">
          {/* <div className='whole' style={{ backgroundColor: "white" }}>
                        {showSnackbar && <div className='snackbar success'>{snackbarMessage}</div>} */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              className="btn btn-md mb-4"
              id="servicecategory"
              onClick={handleFormPremium}
              style={{
                backgroundColor: "green",
                color: "white",
                border: "none",
              }}
            >
              <i className="bi bi-plus-square"> Add Premium Coupon</i>
            </button>

            {/* Search and filter in a row */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              {/* Search input */}
              <Form.Control
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearchPremium(e.target.value)}
                style={{ width: "200px" }}
              />

              {/* Dropdown filter */}
              <select
                className="form-select"
                style={{
                  width: "150px",
                  height: "40px",
                  border: "1px solid #ced4da", // Bootstrap default border
                  borderRadius: "0.375rem", // Bootstrap default border-radius
                }}
                onChange={(e) => setPreStatusFilter(e.target.value)}
                value={prestatusFilter}
              >
                <option value="all">All Coupons</option>
                <option value="active">Active</option>
                <option value="expired">Expired</option>
              </select>
            </div>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              className="btn btn-md mb-4"
              id="servicecategory"
              onClick={handleFormPremium}
              style={{
                backgroundColor: "green",
                color: "white",
                border: "none",
              }}
            >
              <i className="bi bi-plus-square"> Add Premium Coupon</i>
            </button>
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchPremium}
              onChange={(e) => setSearchPremium(e.target.value)}
              className="mb-3"
              style={{ width: "20%", marginRight: "10px" }}
            /> */}
          {/* In the Premium Coupon tab section, replace the existing button group with: */}
          {/* <div className="btn-group mb-3" role="group">
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={() => setPreStatusFilter("all")}
              >
                All Coupons
              </button>
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={() => setPreStatusFilter("active")}
              >
                Active
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => setPreStatusFilter("expired")}
              >
                Expired
              </button>
            </div>
          </div> */}

          <Table
            className="table table-hover table-striped align-middle mt-4"
            style={{ width: "100%", margin: "auto" }}
          >
            <thead>
              <tr>
                <th>S.No</th>
                <th>Coupon Name</th>
                <th>Description</th>
                <th>Discount</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Status</th>

                <th>Active</th>
                <th>Coupon Count</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayedCustomers.length > 0 ? (
                displayedCustomers.map((coupon, index) => (
                  <tr key={coupon.id}>
                    <td>{indexoffree + index + 1}</td>
                    <td>{coupon.coupon_name}</td>{" "}
                    {/* Use the correct field for coupon name */}
                    <td>{coupon.description}</td>{" "}
                    {/* Use the correct field for description */}
                    <td>
                      {coupon.discount_value}
                      {coupon.discount_type === 0 ? "$" : "%"}
                    </td>{" "}
                    {/* Use the correct field for discount value */}
                    <td>{coupon.from_date}</td> {/* Format from_date */}
                    <td>{coupon.to_date}</td> {/* Format to_date */}
                    <td>
                      {(() => {
                        // Parse `to_date` in dd-mm-yyyy format
                        const [day, month, year] = coupon.to_date.split("-");
                        const formattedToDate = new Date(
                          `${year}-${month}-${day}`
                        ); // Convert to yyyy-mm-dd format
                        const today = new Date(); // Current date

                        // Check if the coupon is expired or active
                        return formattedToDate < today ? (
                          <span
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              padding: "5px 10px",
                              borderRadius: "15px",
                              fontWeight: "bold",
                              display: "inline-block",
                            }}
                          >
                            Expired
                          </span>
                        ) : (
                          <span
                            style={{
                              backgroundColor: "green",
                              color: "white",
                              padding: "5px 10px",
                              borderRadius: "15px",
                              fontWeight: "bold",
                              display: "inline-block",
                            }}
                          >
                            Active
                          </span>
                        );
                      })()}
                    </td>
                    <td>
                      <Form.Check
                        type="switch"
                        label=""
                        checked={coupon.is_active === 1}
                        onChange={() =>
                          toggleCouponActivePremium(coupon, coupon.is_active)
                        }
                      />
                    </td>
                    <td>{coupon.used_count}</td>{" "}
                    {/* Coupon count, assuming this is unused count */}
                    <td>
                      <Button
                        type="button"
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleCustomercouponPremium(coupon)}
                      >
                        <i
                          className="bi bi-eye-fill"
                          style={{
                            fontSize: "18px",
                            color: "white",
                            marginRight: "5px",
                          }}
                        ></i>
                      </Button>
                      <Button
                        type="button"
                        variant="warning"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleEditCouponPremium(coupon)}
                      >
                        <i
                          className="bi bi-pencil-square"
                          style={{
                            color: "blue",
                            fontSize: "18px",
                            marginRight: "5px",
                          }}
                        ></i>
                      </Button>
                      <Button
                        type="button"
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleOpenList(coupon.id)}
                      >
                        <i
                          class="bi bi-arrow-right"
                          style={{ fontSize: "21px" }}
                        ></i>
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No coupons found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {/* Pagination Controls */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <ReactPaginate
              class="mt-4"
              style={{ display: "flex", justifyContent: "end" }}
              previousLabel={"← Previous"}
              nextLabel={"Next →"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
          {/* </div> */}

          {/* create Modal for free coupon*/}
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {formData.id ? "Edit Coupon" : "Add Coupon"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="py-2" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="input1"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Coupon Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Coupon Name"
                      id="input1"
                      name="coupon_name"
                      value={formData.coupon_name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="input2"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Coupon Code
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Coupon Code"
                      id="input2"
                      name="coupon_code"
                      value={formData.coupon_code}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="input3"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      id="input3"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputDiscountType"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Type
                    </label>
                  <Form.Control
  as="select"
  name="discount_type"
  value={formData.discount_type}
  onChange={handleInputChange}
  required
>
  <option value="">Select...</option>
  <option value="1">Percentage</option>
  <option value="0">Flat Price</option>
  <option value="2">Service</option> {/* NEW OPTION */}
</Form.Control>

                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputDiscountValue"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Value
                    </label>
              <input
  type="text"
  className="form-control"
  placeholder="Enter value (Price / Percentage / Service Name)"
  id="inputDiscountValue"
  name="discount_value"
  value={formData.discount_value}
  onChange={handleInputChange}
  style={{ borderRadius: "12px" }}
  required
/>

                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputFromDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      From Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputFromDate"
                      name="from_date"
                      value={formData.from_date}
                      onChange={handleInputChange}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputToDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      To Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputToDate"
                      name="to_date"
                      value={formData.to_date}
                      onChange={handleInputChange}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                  </div>
                </div>
                <br />
                <button
                  className="btn btn-success"
                  type="submit"
                  style={{
                    float: "right",
                    margin: "5px",
                    borderRadius: "15px",
                  }}
                >
                  Submit{" "}
                </button>
              </form>
              <button
                className="btn btn-secondary"
                style={{
                  borderRadius: "15px",
                  float: "right",
                  marginTop: "-1px",
                }}
                onClick={resetForm}
              >
                Reset
              </button>
            </Modal.Body>
          </Modal>
          {/* UPdate Modal for free coupon*/}
          <Modal
            show={isEdit}
            onHide={handleCloseEdit}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Coupon</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="py-2">
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="input1"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Coupon Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Coupon Name"
                      id="input1"
                      name="coupon_name"
                      value={formData.coupon_name}
                      onChange={handleInputChange}
                      required
                    />
                    {validationErrors.coupon_name && (
                      <span className="text-danger">
                        {validationErrors.coupon_name}
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <label
                      htmlFor="input2"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Coupon Code
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Coupon Code"
                      id="input2"
                      name="coupon_code"
                      value={formData.coupon_code}
                      onChange={handleInputChange}
                      required
                    />
                    {validationErrors.coupon_code && (
                      <span className="text-danger">
                        {validationErrors.coupon_code}
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <label
                      htmlFor="input3"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      id="input3"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      required
                    />
                    {validationErrors.description && (
                      <span className="text-danger">
                        {validationErrors.description}
                      </span>
                    )}
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputDiscountType"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Type
                    </label>
          <Form.Control
  as="select"
  name="discount_type"
  value={formData.discount_type}
  onChange={handleInputChange}
  required
>
  <option value="">Select...</option>
  <option value="1">Percentage</option>
  <option value="0">Flat Price</option>
  <option value="2">Service</option> {/* NEW OPTION */}
</Form.Control>

{validationErrors.discount_type && (
  <span className="text-danger">
    {validationErrors.discount_type}
  </span>
)}

                    {validationErrors.discount_type && (
                      <span className="text-danger">
                        {validationErrors.discount_type}
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputDiscountValue"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Value
                    </label>
              <input
  type="text"
  className="form-control"
  placeholder="Enter value (Price / Percentage / Service Name)"
  id="inputDiscountValue"
  name="discount_value"
  value={formData.discount_value}
  onChange={handleInputChange}
  style={{ borderRadius: "12px" }}
  required
/>

{validationErrors.discount_value && (
  <span className="text-danger">
    {validationErrors.discount_value}
  </span>
)}

                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputFromDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      From Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputFromDate"
                      name="from_date"
                      value={formData.from_date}
                      onChange={handleInputChange}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                    {validationErrors.from_date && (
                      <span className="text-danger">
                        {validationErrors.from_date}
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputToDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      To Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputToDate"
                      name="to_date"
                      value={formData.to_date}
                      onChange={handleInputChange}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                    {validationErrors.to_date && (
                      <span className="text-danger">
                        {validationErrors.to_date}
                      </span>
                    )}
                  </div>
                </div>
                <br />

                <button
                  className="btn btn-success"
                  style={{
                    float: "right",
                    margin: "5px",
                    borderRadius: "15px",
                  }}
                  onClick={handleEdit}
                >
                  Update{" "}
                </button>
              </form>
              <button
                className="btn btn-secondary"
                style={{
                  borderRadius: "15px",
                  float: "right",
                  marginTop: "-1px",
                }}
                onClick={() => setEdit(false)}
              >
                Close
              </button>
            </Modal.Body>
          </Modal>

          {/* create Modal for premium coupon*/}
          <Modal
            show={showPremium}
            onHide={handleFormPremiumClose}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>{"Add Premium Coupon"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="py-2" onSubmit={handleSubmitPremium}>
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="input1"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Coupon Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Coupon Name"
                      id="input1"
                      name="coupon_name"
                      value={formDataPremiumAdd.coupon_name}
                      onChange={handleInputChangePremium}
                      required
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="input2"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      id="input2"
                      name="description"
                      value={formDataPremiumAdd.description}
                      onChange={handleInputChangePremium}
                      required
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputDiscountType"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Type
                    </label>
                 <Form.Control
  as="select"
  name="discount_type"
  value={formDataPremiumAdd.discount_type}
  onChange={handleInputChangePremium}
  required
>
  <option value="">Select...</option>
  <option value="1">Percentage</option>
  <option value="0">Flat Price</option>
  <option value="2">Service</option> {/* NEW OPTION */}
</Form.Control>

                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputDiscountValue"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Value
                    </label>
              <input
  type="text"
  className="form-control"
  placeholder="Enter value (Price / Percentage / Service Name)"
  id="inputDiscountValue"
  name="discount_value"
  value={formDataPremiumAdd.discount_value}
  onChange={handleInputChangePremium}
  style={{ borderRadius: "12px" }}
  required
/>

                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputFromDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      From Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputFromDate"
                      name="from_date"
                      value={formDataPremiumAdd.from_date}
                      onChange={handleInputChangePremium}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputToDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      To Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputToDate"
                      name="to_date"
                      value={formDataPremiumAdd.to_date}
                      onChange={handleInputChangePremium}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                  </div>
                </div>
                <br />
                <button
                  className="btn btn-success"
                  type="submit"
                  style={{
                    float: "right",
                    margin: "5px",
                    borderRadius: "15px",
                  }}
                >
                  Submit{" "}
                </button>
              </form>
              <button
                className="btn btn-secondary"
                style={{
                  borderRadius: "15px",
                  float: "right",
                  marginTop: "-1px",
                }}
                onClick={resetFormPremium}
              >
                Reset
              </button>
            </Modal.Body>
          </Modal>
          {/* UPdate Modal for premium coupon*/}
          <Modal
            show={isEditPremium}
            onHide={handleCloseEditPremium}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Premium Coupon</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="py-2">
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="input1"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Coupon Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Coupon Name"
                      id="input1"
                      name="coupon_name"
                      value={formDataPremium.coupon_name}
                      onChange={handleInputChangePremiumEdit}
                      required
                    />
                    {validationErrorsPreminum.coupon_name && (
                      <span className="text-danger">
                        {validationErrorsPreminum.coupon_name}
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <label
                      htmlFor="input2"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Description"
                      id="input2"
                      name="description"
                      value={formDataPremium.description}
                      onChange={handleInputChangePremiumEdit}
                      required
                    />
                    {validationErrorsPreminum.description && (
                      <span className="text-danger">
                        {validationErrorsPreminum.description}
                      </span>
                    )}
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputDiscountType"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Type
                    </label>
                <Form.Control
  as="select"
  name="discount_type"
  value={formDataPremium.discount_type}
  onChange={handleInputChangePremiumEdit}
  required
>
  <option value="">Select...</option>
  <option value="1">Percentage</option>
  <option value="0">Flat Price</option>
  <option value="2">Service</option> {/* NEW OPTION */}
</Form.Control>

{validationErrorsPreminum.discount_type && (
  <span className="text-danger">
    {validationErrorsPreminum.discount_type}
  </span>
)}

                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputDiscountValue"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      Discount Value
                    </label>
                <input
  type="text"
  className="form-control"
  placeholder="Enter value (Price / Percentage / Service Name)"
  id="inputDiscountValue"
  name="discount_value"
  value={formDataPremium.discount_value}
  onChange={handleInputChangePremiumEdit}
  style={{ borderRadius: "12px" }}
  required
/>

{validationErrorsPreminum.discount_value && (
  <span className="text-danger">
    {validationErrorsPreminum.discount_value}
  </span>
)}

                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col">
                    <label
                      htmlFor="inputFromDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      From Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputFromDate"
                      name="from_date"
                      value={formDataPremium.from_date}
                      onChange={handleInputChangePremiumEdit}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                    {validationErrorsPreminum.from_date && (
                      <span className="text-danger">
                        {validationErrorsPreminum.from_date}
                      </span>
                    )}
                  </div>
                  <div className="col">
                    <label
                      htmlFor="inputToDate"
                      style={{
                        color: "green",
                        fontFamily: "serif",
                        fontWeight: "bolder",
                      }}
                    >
                      To Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="inputToDate"
                      name="to_date"
                      value={formDataPremium.to_date}
                      onChange={handleInputChangePremiumEdit}
                      style={{ borderRadius: "12px" }}
                      min={formattedDate} // Disable past dates
                      required
                    />
                    {validationErrorsPreminum.to_date && (
                      <span className="text-danger">
                        {validationErrorsPreminum.to_date}
                      </span>
                    )}
                  </div>
                </div>
                <br />

                <button
                  className="btn btn-success"
                  style={{
                    float: "right",
                    margin: "5px",
                    borderRadius: "15px",
                  }}
                  onClick={handleEditPremmium}
                >
                  Update{" "}
                </button>
              </form>
              <button
                className="btn btn-secondary"
                style={{
                  borderRadius: "15px",
                  float: "right",
                  marginTop: "-1px",
                }}
                onClick={() => setEditPremium(false)}
              >
                Close
              </button>
            </Modal.Body>
          </Modal>

          <Modal
            show={showlist}
            onHide={handleCloseList}
            backdrop="static"
            keyboard={false}
            size="xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>{"Customer List"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <strong>Selected Customers: {selectedCoupons.size}</strong>

                <button
                  type="button"
                  className="btn btn-md mb-4"
                  id="servicecategory"
                  onClick={handlePostCoupons}
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    border: "none",
                  }}
                >
                  <i className="bi bi-send"> Send Request</i>
                </button>
              </div>
              <div className="mb-3"></div>
              <Table
                className="table table-hover table-striped align-middle mt-4"
                style={{ width: "100%", margin: "auto" }}
              >
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={selectedCoupons.size === Customers.length} // Check if all are selected
                      />
                    </th>
                    <th>Customer Name</th>
                    <th>Email ID</th>
                    <th>Mobile No</th>
                  </tr>
                </thead>
                <tbody>
                  {Customers.length > 0 ? (
                    Customers.map((coupon, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedCoupons.has(coupon.id)} // Check if this coupon is selected
                            onChange={() => handleCheckboxChange(coupon)} // Use unique identifier here
                          />
                        </td>
                        <td>{coupon.name}</td>
                        <td>{coupon.email_id}</td>
                        <td>{coupon.mobile_no}</td>
                        <td>{coupon.from_date}</td>
                        <td>{coupon.to_date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No coupons found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Modal.Body>
          </Modal>
          <Modal
            show={showAd}
            onHide={handleCloseAd}
            backdrop="false"
            keyboard={false}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              {/* <Modal.Title>{'Cust omer List'}</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <div className="coupon-list">
                {activeCoupon.map((coupon, index) => (
                  <CouponModal key={index} coupon={coupon} />
                ))}
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={showAdPremium}
            onHide={handleCloseAdPremium}
            backdrop="false"
            keyboard={false}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              {/* <Modal.Title>{'Cust omer List'}</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <div className="coupon-list">
                {popupPremiumData ? ( // Check if data exists
                  <CouponModalPremium
                    coupon={popupPremiumData}
                    coupons={referalCode}
                  />
                ) : (
                  <p>No coupon data available</p> // Fallback if no data
                )}
              </div>
            </Modal.Body>
          </Modal>
        </Tab>
      </Tabs>
      {/* </div> */}
      {/* </Container> */}
    </>
  );
};

export default Coupon;
